import { render, staticRenderFns } from "./LayoutWithoutNavbarFlex.vue?vue&type=template&id=178f6fb9&"
import script from "./LayoutWithoutNavbarFlex.vue?vue&type=script&lang=js&"
export * from "./LayoutWithoutNavbarFlex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports